import { useEffect, useState } from 'react';

import ReactDOM from 'react-dom';

import VideoPlayer from 'components/VideoPlayer';

const ArrowCircleDark = require('assets/resources/ArrowCircleDark.svg').default;
const CloseCircleDark = require('assets/resources/CloseCircleDark.svg').default;

const Preview = (props) => {
  const { media_files, close, firstOpen } = props;
  const [currentIndex, setCurrentIndex] = useState(firstOpen);

  useEffect(() => {
    document.documentElement.classList.add('overflow-hidden');
    document.documentElement.classList.add('h-screen');

    return () => {
      document.documentElement.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('h-screen');
    };
  }, []);

  const onPrev = () => {
    let newIndex = currentIndex;
    if (currentIndex === 0) {
      newIndex = media_files.length - 1;
    } else {
      newIndex = currentIndex - 1;
    }
    setCurrentIndex(newIndex);
  };

  const onNext = () => {
    let newIndex = currentIndex;
    if (currentIndex === media_files.length - 1) {
      newIndex = 0;
    } else {
      newIndex = currentIndex + 1;
    }
    setCurrentIndex(newIndex);
  };

  return ReactDOM.createPortal(
    <div data-testid="modal" id="modal" className="fixed inset-0 flex-middle-center z-max bg-black bg-opacity-50 ">
      <div className="relative w-full h-full flex justify-center items-center">
        <div className="absolute top-8 right-10 w-16 h-16 cursor-pointer" onClick={close}>
          <img src={CloseCircleDark} alt="image" width={64} height={64} />
        </div>
        <div className="flex justify-center items-center space-x-10">
          {media_files.length > 1 && <img src={ArrowCircleDark} alt="image" width={64} height={64} className="cursor-pointer" onClick={onPrev} />}

          <div className="flex">
            <div>
              <div className={'w-320 h-167.5 flex overflow-hidden'}>
                {media_files.map((item, index) =>
                  item.type === 'video' ? (
                    <div
                      key={`video-${index}`}
                      className="min-w-320 w-320 h-167.5 flex justify-center items-center transition-transform duration-300 ease-in-out relative"
                      style={{ transform: `translateX(-${currentIndex * 1280}px)` }}
                    >
                      {currentIndex === index ? <VideoPlayer url={item.url} /> : <></>}
                    </div>
                  ) : (
                    <div
                      key={`image-${index}`}
                      className="min-w-320 w-320 h-167.5 flex justify-center items-center transition-transform duration-300 ease-in-out"
                      style={{ transform: `translateX(-${currentIndex * 1280}px)` }}
                    >
                      <img src={item.url} alt="image" className="max-h-167.5 object-contain" />
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
          {media_files.length > 1 && (
            <img src={ArrowCircleDark} className="rotate-180 cursor-pointer" alt="image" width={64} height={64} onClick={onNext} />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Preview;
